export default __webpack_public_path__ + "locales/zh-CN/Profile.json?hash=da71ccfb9f3e1ade58d1fbd05558c440";